
// eslint-disable-next-line import/prefer-default-export

import { lowerCase } from "lodash";
import { httpPost } from "../store/externalCalls/httpCalls";
import noImageXXL from '../components/atoms/customIcons/noImages/noImageXXL.jpg';
import noImageXXLCarousel from '../components/atoms/customIcons/noImages/XXL_Carousel.jpg';
import noImageXLV from '../components/atoms/customIcons/noImages/noImageXLV.jpg';
import noImageXLVCarousel from '../components/atoms/customIcons/noImages/XLV_Carousel.jpg';
import noImageXLH from '../components/atoms/customIcons/noImages/noImageXLH.jpg';
import noImageXLHCarousel from '../components/atoms/customIcons/noImages/XLH_Carousel.jpg';
import noImageLV from '../components/atoms/customIcons/noImages/noImageLV.jpg';
import noImageLVCarousel from '../components/atoms/customIcons/noImages/LV_Carousel.jpg';
import noImageLH from '../components/atoms/customIcons/noImages/noImageLH.jpg';
import noImageLHCarousel from '../components/atoms/customIcons/noImages/LH_Carousel.jpg';
import noImageM from '../components/atoms/customIcons/noImages/noImageM.jpg';
import noImageMCarousel from '../components/atoms/customIcons/noImages/M_Carousel.jpg';
import noImageSV from '../components/atoms/customIcons/noImages/noImageSV.jpg';
import noImageSVCarousel from '../components/atoms/customIcons/noImages/SV_Block.jpg';
import noImageSH from '../components/atoms/customIcons/noImages/noImageSH.jpg';
import noImageSHCarousel from '../components/atoms/customIcons/noImages/SH_Block.jpg';
import noImageXS from '../components/atoms/customIcons/noImages/noImageXS.jpg';
import noImageXSCarousel from '../components/atoms/customIcons/noImages/XS_Block.jpg';


/**
 * Create a url with params store in a object session
 * @param {*} session
 * @param [string] sessionParams
 * @param string url
 */
  export const getCanvasBlockSize = (w,h,isScrollable=false) => {
    const imageSize = {
        '1x1': 'XS',
        '1x2': 'S-V',
        '2x1': 'S-H',
        '4x1': 'S-FW',
        '2x2': 'M',
        '2x3': 'L-V',
        '3x2': 'L-H',
        '2x4': 'XL-V',
        '4x2': 'XL-H',
        '4x4': 'XXL',
      }
    return imageSize[w+'x'+h];
    
  };

  export  const positionCandidates=(canvasMode)=>{
    if(canvasMode=="Top" || canvasMode=="Bottom"){
      return  [
        [0,0],[1,0],[2,0],[3,0]
      ];
    }else{
      return  [
        [0,0],[0,1],[0,2],[0,3],
        [1,0],[1,1],[1,2],[1,3],
        [2,0],[2,1],[2,2],[2,3],
        [3,0],[3,1],[3,2],[3,3]
      ];
    }
  }

  export  const positionCandidatesScrollable=(canvasMode)=>{
    return  [
      [0,0],
      [1,0],
      [2,0],
      [3,0]
    ];
  }

  export const getLongSize=(shortSize)=>{
    switch(shortSize){
      case "XXL":
      case "M":
      case "XS":
        return lowerCase(shortSize);
      break;
      case "XL-V":
        return "xlVertical";
      break;
      case "XL-H":
        return "xlHorizontal";
      break;
      case "L-V":
        return "lVertical";
      break;
      case "L-H":
        return "lHorizontal";
      break;
      case "S-V":
        return "sVertical";
      break;
      case "S-H":
        return "sHorizontal";
      break;
      case "ROW":
        return "sRow";
      default:
        return shortSize;
    }
  }



  export const randomNumberInRange=(min=null, max=null)=> {
    if(min==null)
      min=100000000000;
    if(max==null)
      max=999999999999;
    // 👇️ get number between min (inclusive) and max (inclusive)
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  export const getContainerIndex=(index,maxItems)=>{
    let coef=-1*parseInt(maxItems/2);
    if(maxItems%2==0)
      coef=-1*parseInt(maxItems/2)+1;

    return coef+index;
  }
  export const getTimestampFromDate15Min=(date=null,timestamp=null)=>{
    var round = 1000 * 60 * 15;
    let d;
    if(date){
      d=new Date();
    }
    if(timestamp){
      d =new Date(timestamp);
    }
    var rounded = new Date(Math.floor(d.getTime() / round) * round);
    return rounded.getTime();
  }


  export const permittedSizes = ['1x1', '1x2','2x1','2x2','2x3','3x2','2x4','4x2','4x4'];
  export const permittedSizesSmall = ['1x1','2x1','4x1'];
  export const permittedSizesScrollable=['4x1'];
  
  export const prettyNameFromType=(type)=>{
    if(type==null)
      return "Empty block";
    switch(type){
      case "sportRoom":
        return "Room";
      break;
      case "highlightedContent":
        return "Video";
      break;
      case "staticImage":
        return "Static graphic";
      break;
      case "backgroundImage":
        return "Background Image";
      break;
      case "calendar":
        return "Calendar";
      break;
      case "interactableGraphics":
        return "Interactable graphic";
      break;
      case "contentCategory":
        return "Content category";
      break;
      case "App2AppTravel":
        return "App2App travel";
      break;
      case "carousel":
        return "Carousel";
    }
  }
  

  export const loadInfoBlock = (block,session,scrollable,func)=>{
    let postURL;
    let contentBlock=block.contents;
    switch(contentBlock.type){
      case "contentCategory":
        postURL="canvasContentCategoryInfo/"+session.areaId;
      break;
      case "staticImage":
        postURL="canvasStaticImageInfo";
      break;
      case "highlightedContent":
        postURL="canvasHighlightedContentInfo";
      break;
      case "externalContent":
        postURL="canvasHighlightedContentInfo";
      break;
      case "interactableGraphics":
        postURL="canvasInteractableGraphicsInfo";
      break;
      case "calendar":
        postURL="canvasCalendarInfo";  
      break;
      case "carousel":
        postURL="canvasCarouselInfo";  
      break;
      case "spacesCarousel":
        postURL="canvasSpacesCarouselInfo";  
      break;
      case "sportRoom":
        postURL="canvasSportRoomInfo";
      break;
      case "App2AppTravel":
        postURL="canvasApp2AppTravelInfo";
      break;
    }
    let content=JSON.parse(contentBlock.content);
    
    content.canvasContentId=block.id;
    content.size=getCanvasBlockSize(block.w,block.h,scrollable);
    httpPost(postURL,content).then((info)=>{
      func(info);
    }).catch(error=>{
    });
  }
  export const getIframeSizes=(size)=>{
    console.log("size",size);
    switch(size){
      case "XXL":
        return [416,416];
        break;
      case "XL-V":
        return [318,664];
        break;
      case "XL-H":
        return [416,210];
        break;
      case "S-FW":
        return [416,80];
        break;
      case "S-V":
        return [145,318];
        break;
      case "S-H":
          return [318,145];
          break;
      case "M":
        return [318,318];
        break;
      case "XS":
        return [145,145];
        break;
      default:
        return [500,500];
        break;
    }
  }
  export const GetImgNoImage=(size,mode=null)=>{
      switch(size){
        case "XXL":
          if(mode=="carousel")
            return noImageXXLCarousel;
          else
            return noImageXXL;
        break;
        case "XL-V":
          if(mode=="carousel")
            return noImageXLVCarousel;
          else
            return noImageXLV;
        break;
        case "XL-H":
          if(mode=="carousel")
            return noImageXLHCarousel;
          else
            return noImageXLH;
        break;
        case "L-V":
          if(mode=="carousel")
            return noImageLVCarousel;
          else  
            return noImageLV;
        break;
        case "L-H":
          if(mode=="carousel")
            return noImageLHCarousel;
          else  
            return noImageLH;
        break;
        case "M":
          if(mode=="carousel")
            return noImageMCarousel;
          else  
            return noImageM;
        break;
        case "S-V":
          if(mode=="carousel")
            return noImageSVCarousel;
          else  
            return noImageSV;
        break;
        case "S-H":
          if(mode=="carousel")
            return noImageSHCarousel;
          else  
            return noImageSH;
        break;
        case "XS":
          if(mode=="carousel")
            return noImageXSCarousel;
          else  
            return noImageXS;
      }
  }
